import React from "react";
import { Container, Box, Typography, Divider, Paper } from "@mui/material";
import JumboCardQuick from "@jumbo/components/JumboCardQuick";

const PrivacyPolicy = () => {
  return (
      <JumboCardQuick wrapperSx={{ pt: 0 }}>
          <Typography
            variant="h3"
            align="center"
            gutterBottom
            sx={{ fontWeight: 700, my: 4, color: "text.primary" }}
          >
            Privacy Policy
          </Typography>

          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h5"
              gutterBottom
              sx={{ fontWeight: 600, color: "text.primary" }}
            >
              1. Introduction
            </Typography>
            <Typography
              variant="body2"
              sx={{ lineHeight: 1.8, color: "text.secondary" }}
            >
              Welcome to CodingPal.org. We are committed to protecting your
              privacy and ensuring the security of your personal information.
              This Privacy Policy outlines how we collect, use, and protect your
              data.
            </Typography>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h5"
              gutterBottom
              sx={{ fontWeight: 600, color: "text.primary" }}
            >
              2. Information We Collect
            </Typography>
            <Typography
              variant="body2"
              sx={{ lineHeight: 1.8, color: "text.secondary" }}
            >
              a. Personal Information: When you register for an account,
              subscribe to our services, or contact us, we may collect personal
              information such as your name, email address, phone number, and
              payment details.
              <br />
              b. Usage Data: We collect information on how you access and use the
              CodingPal.org website, including your IP address, browser type,
              pages visited, time spent on pages, and other usage statistics.
              <br />
              c. Cookies: We use cookies and similar tracking technologies to
              track activity on our website and hold certain information. You can
              control the use of cookies at the individual browser level.
            </Typography>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h5"
              gutterBottom
              sx={{ fontWeight: 600, color: "text.primary" }}
            >
              3. How We Use Your Information
            </Typography>
            <Typography
              variant="body2"
              sx={{ lineHeight: 1.8, color: "text.secondary" }}
            >
              a. To Provide and Maintain Our Services: We use your personal
              information to create and manage your account, provide customer
              support, and process transactions.
              <br />
              b. To Improve Our Services: Usage data helps us understand how our
              services are being used and allows us to make improvements.
              <br />
              c. To Communicate with You: We may use your information to send
              newsletters, promotional materials, and other information that may
              be of interest to you. You can opt out of these communications at
              any time by following the unsubscribe link in the emails or by
              contacting us at sai@codingpal.org.
              <br />
              d. To Enforce Our Terms: We use your information to enforce our
              terms and conditions, including detecting and preventing fraud or
              other unauthorized activities.
            </Typography>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h5"
              gutterBottom
              sx={{ fontWeight: 600, color: "text.primary" }}
            >
              4. Sharing Your Information
            </Typography>
            <Typography
              variant="body2"
              sx={{ lineHeight: 1.8, color: "text.secondary" }}
            >
              a. Third-Party Service Providers: We may share your information
              with third-party service providers who perform services on our
              behalf, such as payment processing, data analysis, email delivery,
              hosting services, and customer service.
              <br />
              b. Legal Requirements: We may disclose your information if required
              to do so by law or in response to valid requests by public
              authorities (e.g., a court or a government agency).
              <br />
              c. Business Transfers: In the event of a merger, acquisition, or
              sale of assets, your personal information may be transferred to the
              new entity.
            </Typography>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h5"
              gutterBottom
              sx={{ fontWeight: 600, color: "text.primary" }}
            >
              5. Data Security
            </Typography>
            <Typography
              variant="body2"
              sx={{ lineHeight: 1.8, color: "text.secondary" }}
            >
              We implement a variety of security measures to maintain the safety
              of your personal information. However, no method of transmission
              over the internet or electronic storage is 100% secure. While we
              strive to use commercially acceptable means to protect your
              personal information, we cannot guarantee its absolute security.
            </Typography>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h5"
              gutterBottom
              sx={{ fontWeight: 600, color: "text.primary" }}
            >
              6. Data Retention
            </Typography>
            <Typography
              variant="body2"
              sx={{ lineHeight: 1.8, color: "text.secondary" }}
            >
              We will retain your personal information only for as long as
              necessary to fulfill the purposes for which it was collected or to
              comply with legal obligations.
            </Typography>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h5"
              gutterBottom
              sx={{ fontWeight: 600, color: "text.primary" }}
            >
              7. Your Rights
            </Typography>
            <Typography
              variant="body2"
              sx={{ lineHeight: 1.8, color: "text.secondary" }}
            >
              a. Access and Update: You have the right to access and update your
              personal information. You can do this through your account settings
              or by contacting us at sai@codingpal.org.
              <br />
              b. Deletion: You have the right to request the deletion of your
              personal information. We will comply with your request, subject to
              certain exceptions prescribed by law.
              <br />
              c. Opt-Out: You have the right to opt-out of receiving promotional
              communications from us. You can do this by following the
              unsubscribe link in the emails or by contacting us at
              sai@codingpal.org.
            </Typography>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h5"
              gutterBottom
              sx={{ fontWeight: 600, color: "text.primary" }}
            >
              8. Children's Privacy
            </Typography>
            <Typography
              variant="body2"
              sx={{ lineHeight: 1.8, color: "text.secondary" }}
            >
              Our services are not intended for use by individuals under the age
              of 18. We do not knowingly collect personal information from
              children under 18. If you become aware that a child has provided us
              with personal information, please contact us, and we will take
              steps to remove such information and terminate the child's account.
            </Typography>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h5"
              gutterBottom
              sx={{ fontWeight: 600, color: "text.primary" }}
            >
              9. Changes to This Privacy Policy
            </Typography>
            <Typography
              variant="body2"
              sx={{ lineHeight: 1.8, color: "text.secondary" }}
            >
              We may update our Privacy Policy from time to time. We will notify
              you of any changes by posting the new Privacy Policy on this page.
              You are advised to review this Privacy Policy periodically for any
              changes.
            </Typography>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h5"
              gutterBottom
              sx={{ fontWeight: 600, color: "text.primary" }}
            >
              10. Contact Us
            </Typography>
            <Typography
              variant="body2"
              sx={{ lineHeight: 1.8, color: "text.secondary" }}
            >
              If you have any questions or concerns about this Privacy Policy,
              please contact us at sai@codingpal.org.
            </Typography>
          </Box>
      </JumboCardQuick>
  );
};

export default PrivacyPolicy;